import { Link } from '~/elements/Link/Link'

type Props = {}

export const PreviewModeHeader = ({}: Props) => {
  return (
    <div className="relative z-50 w-full bg-primary-white">
      Preview Mode is enabled. <Link href="/api/exit-preview">Disable</Link>
    </div>
  )
}
